"use strict";

require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.number.constructor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.number.constructor.js");
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _vuePropertyDecorator = require("vue-property-decorator");
var _utils = require("../utils");
var _fixTop = _interopRequireDefault(require("../mixins/fix-top"));
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8; // import native from '@zz-common/native-adapter'
var fixedMainDomTop = 0;
var fixedSubDomTop = 0;
var fixedHeaderDom = null;
var fixedFooterDom = null;
var fixedMainDom = null;
var fixedSubDom = null;
var abserveTarget = null;
var observe = null;
var _native;

// 考虑ssr，动态引入
if (!_utils.isServer) {
  _native = require('@zz-common/native-adapter').default; // eslint-disable-line global-require
}

var PageBaseBox = (_dec = (0, _vuePropertyDecorator.Prop)({
  type: String,
  required: false,
  default: '搜索热词'
}), _dec2 = (0, _vuePropertyDecorator.Prop)({
  type: String,
  required: false,
  default: ''
}), _dec3 = (0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  required: false,
  default: false
}), _dec4 = (0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  required: false,
  default: false
}), _dec5 = (0, _vuePropertyDecorator.Prop)({
  type: Object,
  required: false,
  default: function _default() {
    return {};
  }
}), _dec6 = (0, _vuePropertyDecorator.Prop)(), _dec7 = (0, _vuePropertyDecorator.Prop)({
  type: String,
  required: false,
  default: '1'
}), _dec8 = (0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
}), (0, _vuePropertyDecorator.Component)(_class = (_class2 = /*#__PURE__*/function (_FixTopMixin) {
  (0, _inheritsLoose2.default)(PageBaseBox, _FixTopMixin);
  function PageBaseBox() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _FixTopMixin.call.apply(_FixTopMixin, [this].concat(args)) || this;
    // 顶部搜索框中搜索词
    (0, _initializerDefineProperty2.default)(_this, "searchWords", _descriptor, (0, _assertThisInitialized2.default)(_this));
    // 页面向下滑动替换标题栏颜色
    (0, _initializerDefineProperty2.default)(_this, "scrollFixedHeaderTaskbarBG", _descriptor2, (0, _assertThisInitialized2.default)(_this));
    // 头部吸顶是否被覆盖
    (0, _initializerDefineProperty2.default)(_this, "fixedHeaderBeCovered", _descriptor3, (0, _assertThisInitialized2.default)(_this));
    // 一级吸顶是否被覆盖
    (0, _initializerDefineProperty2.default)(_this, "fixedMainBeCovered", _descriptor4, (0, _assertThisInitialized2.default)(_this));
    // 组件样式
    (0, _initializerDefineProperty2.default)(_this, "slotStyle", _descriptor5, (0, _assertThisInitialized2.default)(_this));
    // 顶部标题
    (0, _initializerDefineProperty2.default)(_this, "title", _descriptor6, (0, _assertThisInitialized2.default)(_this));
    // 顶部展示类型 1|返回按钮+标题（默认）；2|返回按钮+搜索框; 传入fixedHeaderSlot 与内容默认使用自定义样式
    (0, _initializerDefineProperty2.default)(_this, "headerShowType", _descriptor7, (0, _assertThisInitialized2.default)(_this));
    // 是否展示page-base-box的header
    (0, _initializerDefineProperty2.default)(_this, "needBoxHead", _descriptor8, (0, _assertThisInitialized2.default)(_this));
    // 头部信息
    _this.headerTitle = '';
    // 是否是iphoneX
    _this.isIphoneX = _utils.isiPhoneX;
    // 一级吸顶
    _this.isMainFixed = false;
    // 二级吸顶
    _this.isSubFixed = false;
    // 一级吸顶高度
    _this.mainHeight = 0;
    // 底部吸底高度
    _this.footerHeight = 0;
    return _this;
  }
  var _proto = PageBaseBox.prototype;
  _proto.render = function () {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      class: ['page_base', {
        'is_ios': _vm.isIOS,
        'is_iphonex': _vm.isIphoneX,
        'is_app': _vm.isApp
      }],
      style: {
        paddingBottom: _vm.footerHeight + 'px'
      }
    }, [_vm.needHideHead ? _c('div', {
      ref: "fixedHeaderDom",
      staticClass: "fixed_header",
      style: Object.assign({}, {
        background: _vm.scrollFlag ? _vm.scrollFixedHeaderTaskbarBG : _vm.headerTaskbarBG,
        paddingTop: _vm.htmlPaddingTop + 'px',
        minHeight: _vm.$slots['fixedHeaderSlot'] ? '0px' : '45px'
      }, _vm.slotStyle.fixedHeaderSlot)
    }, [!_vm.$slots['fixedHeaderSlot'] && _vm.isApp ? _c('div', {
      staticClass: "back_icon",
      style: {
        top: _vm.htmlPaddingTop + 'px'
      },
      on: {
        "click": _vm.goBackEvent
      }
    }, [_vm._v(" < ")]) : _vm._e(), _vm.$slots['fixedHeaderSlot'] ? _c('div', {
      staticClass: "slot"
    }, [_vm._t("fixedHeaderSlot")], 2) : _vm.headerShowType === '1' ? _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.headerTitle))]) : _vm.headerShowType === '2' ? _c('div', {
      staticClass: "search"
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(_vm.searchWords))])]) : _vm._e()]) : _vm._e(), _c('div', {
      staticClass: "header_info",
      style: Object.assign({}, {
        paddingTop: _vm.headerHeight + 'px'
      }, _vm.slotStyle.headerInfoSlot)
    }, [_vm._t("headerInfoSlot")], 2), _vm.$slots['fixedMainSlot'] || _vm.$slots['fixedSubSlot'] ? _c('div', {
      ref: "fixedMainDom",
      class: ['fixed_main', {
        fixed_area: _vm.isMainFixed
      }],
      style: Object.assign({}, {
        top: _vm.fixedMainOffsetTop + 'px'
      }, _vm.slotStyle.fixedMainSlot),
      attrs: {
        "id": "fixedMainObserve"
      }
    }, [_vm._t("fixedMainSlot")], 2) : _vm._e(), _vm.$slots['mainInfoSlot'] ? _c('div', {
      staticClass: "main_info",
      style: Object.assign({}, _vm.slotStyle.mainInfoSlot)
    }, [_vm._t("mainInfoSlot")], 2) : _vm._e(), _vm.$slots['fixedSubSlot'] ? _c('div', {
      ref: "fixedSubDom",
      class: ['fixed_sub', {
        fixed_area: _vm.isSubFixed
      }],
      style: Object.assign({}, {
        top: _vm.fixedSubOffsetTop + 'px'
      }, _vm.slotStyle.fixedSubSlot)
    }, [_vm._t("fixedSubSlot")], 2) : _vm._e(), _vm.$slots['mainInfoSlot'] ? _c('div', {
      staticClass: "sub_info",
      style: Object.assign({}, _vm.slotStyle.subInfoSlot)
    }, [_vm._t("subInfoSlot")], 2) : _vm._e(), _vm._t("default"), _vm.$slots['fixedFooter'] ? _c('div', {
      ref: "fixedFooterDom",
      staticClass: "fixed_footer",
      style: Object.assign({}, _vm.slotStyle.fixedFooter)
    }, [_vm._t("fixedFooter")], 2) : _vm._e()], 2);
  };
  _proto.created = function created() {
    if (_utils.isServer) return;
    this.headerTitle = this.title || document.title || '页面标题';
  };
  _proto.mounted = function mounted() {
    var _this2 = this;
    if (!_utils.isServer && this.$expandAdapter) _native = this.$expandAdapter;
    fixedHeaderDom = this.$refs.fixedHeaderDom;
    fixedFooterDom = this.$refs.fixedFooterDom;
    fixedMainDom = this.$refs.fixedMainDom;
    fixedSubDom = this.$refs.fixedSubDom;
    setTimeout(function () {
      _this2.initDom();
    }, 0);
  };
  _proto.destroyed = function destroyed() {
    if (_utils.isServer) return;
    window.removeEventListener('scroll', this.scrollEventProcess);
    window.removeEventListener('scroll', this.scrollEventSetFlag);
    this.removeAbserve();
  }
  // 初始化页面元素及位置
  ;

  _proto.initDom = function initDom() {
    console.log('---initDom', this.getTargetRect(fixedHeaderDom));
    this.headerHeight = this.getTargetRect(fixedHeaderDom).height;
    this.footerHeight = this.getTargetRect(fixedFooterDom).height;
    this.mainHeight = this.fixedMainBeCovered ? 0 : this.getTargetRect(fixedMainDom).height;
    if (this.$slots.fixedMainSlot) {
      abserveTarget = document.getElementById('fixedMainObserve');
      this.addAbserve(abserveTarget);
    }
    if (this.cssSupport('position', 'sticky')) {
      if (!this.scrollFixedHeaderTaskbarBG) return;
      return window.addEventListener('scroll', this.throttleFunc(this.scrollEventSetFlag, 100, 200));
    }
    console.log('没有找到元素或该系统不支持sticky', fixedMainDom);
    if (fixedMainDom) {
      fixedMainDomTop = this.getTargetRect(fixedMainDom).top;
      fixedSubDomTop = this.getTargetRect(fixedSubDom).top;
      window.addEventListener('scroll', this.throttleFunc(this.scrollEventProcess, 100, 200));
    }
  }
  // 检测dom元素属性并返回值
  ;

  _proto.getTargetRect = function getTargetRect(target) {
    console.log('---getTargetRect');
    if (target && target.getBoundingClientRect()) {
      return target.getBoundingClientRect();
    }
    return {
      height: 0,
      top: 0
    };
  }
  // 是否支持css样式
  ;

  _proto.cssSupport = function cssSupport(attr, value) {
    console.log('---cssSupport');
    if (fixedMainDom && fixedMainDom.style && attr in fixedMainDom.style) {
      fixedMainDom.style[attr] = value;
      if (fixedSubDom) {
        fixedSubDom.style[attr] = value;
      }
      return fixedMainDom.style[attr] === value;
    } else {
      return false;
    }
  }
  // 页面滚动替换标题栏图片
  ;

  _proto.scrollEventSetFlag = function scrollEventSetFlag() {
    var scroll2Top = function scroll2Top() {
      return document.documentElement.scrollTop || document.body.scrollTop;
    };
    this.isMainFixed = scroll2Top() > this.headerHeight;
  }
  // 页面滚动，tab吸顶逻辑
  ;

  _proto.scrollEventProcess = function scrollEventProcess() {
    console.log('---scrollEventProcess');
    var scroll2Top = function scroll2Top() {
      return document.documentElement.scrollTop || document.body.scrollTop;
    };
    console.log('scroll', scroll2Top(), fixedMainDomTop);
    // -2 是避免一些偏差
    this.isMainFixed = scroll2Top() >= fixedMainDomTop - 2;
    this.isSubFixed = scroll2Top() >= fixedSubDomTop - 2 - this.mainHeight - this.headerHeight;
  }
  // 滚动节流
  ;

  _proto.throttleFunc = function throttleFunc(func, wait, mustRun) {
    var _arguments = arguments,
      _this3 = this;
    console.log('---throttleFunc');
    var timeout;
    var startTime = Number(new Date());
    return function () {
      var context = _this3;
      var args = _arguments;
      var curTime = Number(new Date());
      clearTimeout(timeout);
      // 如果达到了规定的触发时间间隔，触发 handler
      if (curTime - startTime >= mustRun) {
        func.apply(context, args);
        startTime = curTime;
        // 没达到触发间隔，重新设定定时器
      } else {
        timeout = setTimeout(func, wait);
      }
    };
  }
  // 点击返回
  ;

  _proto.goBackEvent = function goBackEvent() {
    // 判断有无goBack事件传入，如无则执行默认返回事件
    if (this.$listeners.goBack) {
      return this.$emit('goBack');
    }
    if (history.length > 1) {
      // history.length 只是记录路由栈里有几个路由，并不是记录当前路由之前还有几个路由，
      // 所以不能认为 history.length > 1，就认为还有hash路由，需要进行一个判断
      history.back();
      var timer = setTimeout(function () {
        _native.wrap('close')();
      }, 200);
      window.onpopstate = function () {
        // 如果触发了此方法，说明 hash路由改变了，否则说明并没有hash路由了，直接关闭 webview
        clearTimeout(timer);
      };
    } else {
      // 没有 hash路由栈，则直接关掉当前 webview
      _native.wrap('close')();
    }
  }
  // 添加观察者
  ;

  _proto.addAbserve = function addAbserve(target) {
    var _this4 = this;
    console.log('---addAbserve');
    observe = new MutationObserver(function (mutations, observe) {
      _this4.mainHeight = _this4.getTargetRect(abserveTarget).height;
    });
    observe.observe(target, {
      childList: true,
      subtree: true
    });
  }
  // 移除观察者
  ;

  _proto.removeAbserve = function removeAbserve() {
    console.log('---removeAbserve');
    observe && observe.disconnect();
  };
  (0, _createClass2.default)(PageBaseBox, [{
    key: "fixedMainOffsetTop",
    get:
    // 获得一级吸顶距离顶部的距离
    function get() {
      var offsetTop = this.headerHeight;
      console.log('hahah', offsetTop, this.fixedHeaderBeCovered, this.htmlPaddingTop);
      if (this.fixedHeaderBeCovered) {
        var step = this.htmlPaddingTop;
        offsetTop = step;
      }
      return offsetTop;
    }
    // 吸顶标志位
  }, {
    key: "scrollFlag",
    get: function get() {
      return this.isMainFixed;
    }
    // 获得二级吸顶距离顶部的距离
  }, {
    key: "fixedSubOffsetTop",
    get: function get() {
      var offsetTop = this.fixedMainOffsetTop + this.mainHeight;
      return offsetTop;
    }
  }]);
  return PageBaseBox;
}(_fixTop.default), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "searchWords", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "scrollFixedHeaderTaskbarBG", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "fixedHeaderBeCovered", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "fixedMainBeCovered", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "slotStyle", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "title", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "headerShowType", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "needBoxHead", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
exports.default = PageBaseBox;